document.addEventListener('DOMContentLoaded', function () {
  const LIST_ID = 'suggested_bundle_dropdown';
  const LIST_NAME = 'Suggested Bundle Dropdown';

  let widgetIdFromUrl = ''
  let widgetIdList = []
  const loadedWidgetIdList = []
  let loadedAllWidgets = false
  const rebuyByobSuggestedDataElem = document.querySelector('#rebuy-byob-suggested-data')
  let rebuyByobSuggestedData = null
  if(rebuyByobSuggestedDataElem) {
    const rebuyByobSuggestedTemp = JSON.parse(rebuyByobSuggestedDataElem.textContent)
    if(rebuyByobSuggestedTemp['list'].length) {
      rebuyByobSuggestedData = rebuyByobSuggestedTemp
    }
  }

  /** @type {Record<string, object>} widgetId -> enriched option payload */
  const suggestedBundleOptionCache = {}
  let lastSelectedBundle = null
  let dropdownIsOpen = false
  let dropdownViewFired = false
  let dropdownViewPending = false
  let dropdownViewObserver = null
  let optionViewFiredForOpen = false

  const getCurrency = () => window.shopSettings?.isoCode || 'USD'

  const getVariantIdFromUrl = (linkElem) => {
    let strArr = linkElem.getAttribute('href').split('variant=')
    const [first, second] = strArr
    strArr = typeof second !== 'undefined' ? second.split('&') : []
    const [variantId] = strArr
    return variantId
  }

  const parseMoney = (text) => {
    if (!text) return 0
    const cleaned = String(text).replace(/[^0-9.,]/g, '')
    if (!cleaned) return 0
    // Prefer last decimal as cents separator when both , and . appear
    if (cleaned.includes(',') && cleaned.includes('.')) {
      const lastComma = cleaned.lastIndexOf(',')
      const lastDot = cleaned.lastIndexOf('.')
      if (lastComma > lastDot) {
        return Number.parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) || 0
      }
      return Number.parseFloat(cleaned.replace(/,/g, '')) || 0
    }
    if (cleaned.includes(',')) {
      const parts = cleaned.split(',')
      if (parts[parts.length - 1].length === 2) {
        return Number.parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) || 0
      }
      return Number.parseFloat(cleaned.replace(/,/g, '')) || 0
    }
    return Number.parseFloat(cleaned) || 0
  }

  // Rebuy product/variant `.price` values are major currency units (e.g. 28 or "28.00").
  // Do not treat integers as Shopify cents — that turns $28 into 0.28.
  const toMajorCurrency = (raw) => {
    if (raw == null || raw === '') return 0
    if (typeof raw === 'string' && /[^\d.]/.test(raw)) return parseMoney(raw)
    const n = Number(raw)
    return Number.isFinite(n) ? n : 0
  }

  const extractProductsFromWidgetApi = (widget) => {
    const products = widget?.products || widget?.data?.products || []
    if (!Array.isArray(products) || !products.length) return null

    return products.map((product) => {
      const variant =
        product.selected_variant ||
        product.variant ||
        (Array.isArray(product.variants) ? product.variants[0] : null) ||
        {}
      const variantId = variant.id || product.selected_variant_id || product.variant_id || ''
      const productId = product.id || product.product_id || variant.product_id || ''
      const price = toMajorCurrency(
        variant.price ?? product.price ?? product.compare_at_price ?? 0
      )

      return {
        item_name: product.title || product.name || '',
        item_id: String(productId || ''),
        item_variant_id: String(variantId || ''),
        item_variant: variant.title || product.variant_title || '',
        price,
        quantity: 1
      }
    })
  }

  const extractProductsFromDom = (widgetId) => {
    const widgetBlock = document.querySelector(`.rebuy-byob div[data-rebuy-id="${widgetId}"]`)
    if (!widgetBlock) return []

    return [...widgetBlock.querySelectorAll('.rebuy-product-block')].map((block) => {
      const titleLink =
        block.querySelector('a.rebuy-product-title') ||
        block.querySelector('.rebuy-product-title a')
      const title =
        (titleLink?.textContent || block.querySelector('.rebuy-product-title')?.textContent || '')
          .trim()
      const variantId = titleLink ? getVariantIdFromUrl(titleLink) || '' : ''
      const productId =
        block.getAttribute('data-product-id') ||
        block.getAttribute('data-rebuy-product-id') ||
        block.dataset?.productId ||
        ''
      const priceEl =
        block.querySelector('.rebuy-product-price .rebuy-money') ||
        block.querySelector('.rebuy-product-price')
      // Prefer visible money text (always major units) over data-price attrs
      const price = parseMoney(priceEl?.textContent || '')

      return {
        item_name: title,
        item_id: String(productId || ''),
        item_variant_id: String(variantId || ''),
        item_variant: '',
        price,
        quantity: 1
      }
    })
  }

  const buildOptionPayload = (bundleMeta, position) => {
    const cached = suggestedBundleOptionCache[bundleMeta.widget_id]
    let products = cached?.products
    const needsDomRefresh =
      !products?.length ||
      products.every((product) => !product.item_variant_id && !product.item_id)
    if (needsDomRefresh) {
      const fromDom = extractProductsFromDom(bundleMeta.widget_id)
      if (fromDom.length) {
        products = fromDom
        suggestedBundleOptionCache[bundleMeta.widget_id] = { products }
      }
    }
    products = products || []

    const price = products.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
    const productIds = products.map((p) => p.item_id).filter(Boolean)
    const variantIds = products.map((p) => p.item_variant_id).filter(Boolean)
    const currency = getCurrency()

    const items = products.map((product) => ({
      ...product,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      index: position,
      item_bundle_name: bundleMeta.label,
      item_bundle_id: String(bundleMeta.widget_id)
    }))

    // Single-row summary for GTM variables that expect one option object
    const suggested_bundle = {
      bundle_name: bundleMeta.label,
      bundle_id: String(bundleMeta.widget_id),
      product_id: productIds.join(',') || String(bundleMeta.widget_id),
      variant_id: variantIds.join(','),
      price,
      position,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME
    }

    return {
      suggested_bundle,
      ecommerce: {
        currency,
        value: price,
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: items.length
          ? items
          : [{
              item_name: bundleMeta.label,
              item_id: String(bundleMeta.widget_id),
              item_variant_id: '',
              price,
              index: position,
              quantity: 1,
              item_list_id: LIST_ID,
              item_list_name: LIST_NAME,
              item_bundle_name: bundleMeta.label,
              item_bundle_id: String(bundleMeta.widget_id)
            }]
      }
    }
  }

  const getAllOptionPayloads = () => {
    if (!rebuyByobSuggestedData?.list?.length) return []
    return rebuyByobSuggestedData.list.map((item, index) =>
      buildOptionPayload(item, index + 1)
    )
  }

  // Wait until each suggested widget has fired rebuy.ready (cache entry set),
  // so the view event is not locked to empty fallback items from first paint.
  const optionsPayloadIsReady = () => {
    if (!rebuyByobSuggestedData?.list?.length) return false
    return rebuyByobSuggestedData.list.every((item) =>
      Boolean(suggestedBundleOptionCache[item.widget_id])
    )
  }

  const syncLastSelectedFromValue = (widgetId) => {
    if (!widgetId || !rebuyByobSuggestedData?.list?.length) {
      lastSelectedBundle = null
      return null
    }

    const position =
      rebuyByobSuggestedData.list.findIndex((item) => item.widget_id === widgetId) + 1
    const bundleMeta = rebuyByobSuggestedData.list.find(
      (item) => item.widget_id === widgetId
    )
    if (!bundleMeta || position < 1) {
      lastSelectedBundle = null
      return null
    }

    const payload = buildOptionPayload(bundleMeta, position)
    lastSelectedBundle = payload
    return payload
  }

  const trackDropdownView = () => {
    if (dropdownViewFired || !window.GTMDataLayer) return
    if (!optionsPayloadIsReady()) {
      dropdownViewPending = true
      return
    }

    dropdownViewFired = true
    dropdownViewPending = false
    if (dropdownViewObserver) {
      dropdownViewObserver.disconnect()
      dropdownViewObserver = null
    }
    const options = getAllOptionPayloads()
    window.GTMDataLayer.suggestedBundleDropdownView({
      suggested_bundle_dropdown: {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        option_count: options.length
      },
      ecommerce: {
        currency: getCurrency(),
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: options.flatMap((option) => option.ecommerce.items)
      }
    })
  }

  const trackDropdownOpen = () => {
    if (!window.GTMDataLayer) return
    const options = getAllOptionPayloads()
    window.GTMDataLayer.suggestedBundleDropdownOpen({
      suggested_bundle_dropdown: {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        option_count: options.length
      },
      ecommerce: {
        currency: getCurrency(),
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: options.flatMap((option) => option.ecommerce.items)
      }
    })

    if (!optionViewFiredForOpen) {
      optionViewFiredForOpen = true
      options.forEach((option) => {
        window.GTMDataLayer.suggestedBundleOptionView(option)
      })
    }
  }

  const trackDropdownClose = (reason = 'dismissed') => {
    if (!window.GTMDataLayer) return
    window.GTMDataLayer.suggestedBundleDropdownClose({
      suggested_bundle_dropdown: {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        close_reason: reason
      }
    })
  }

  // Safari on Apple platforms opens the native <select> with ArrowUp/ArrowDown.
  // Elsewhere those keys usually change the value while the list stays closed.
  const arrowsOpenNativeSelect = (() => {
    const ua = navigator.userAgent || ''
    const isApple =
      /Mac|iPhone|iPad|iPod/.test(navigator.platform || '') ||
      /Mac OS X|iPhone|iPad|iPod/.test(ua)
    const isSafari = /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg|Android/i.test(ua)
    return isApple && isSafari
  })()

  const bindSuggestedBundleAnalytics = (selectEl) => {
    const markOpen = () => {
      if (dropdownIsOpen) return
      dropdownIsOpen = true
      optionViewFiredForOpen = false
      trackDropdownOpen()
    }

    const markClosed = (reason) => {
      if (!dropdownIsOpen) return
      dropdownIsOpen = false
      trackDropdownClose(reason)
    }

    selectEl.addEventListener('mousedown', () => {
      // Native select toggles open on mousedown; treat as open if closed
      if (!dropdownIsOpen) {
        markOpen()
      }
    })

    selectEl.addEventListener('keydown', (event) => {
      // Space/Enter open broadly. Alt+ArrowDown opens on Windows/Linux.
      // ArrowUp/Down open only on macOS Safari (elsewhere they change value closed).
      const opensList =
        event.key === 'Enter' ||
        event.key === ' ' ||
        event.key === 'Spacebar' ||
        (event.key === 'ArrowDown' && event.altKey) ||
        (arrowsOpenNativeSelect &&
          (event.key === 'ArrowDown' || event.key === 'ArrowUp') &&
          !event.altKey)
      if (opensList && !dropdownIsOpen) {
        markOpen()
      }
      if (event.key === 'Escape' && dropdownIsOpen) {
        markClosed('dismissed')
      }
    })

    selectEl.addEventListener('change', (event) => {
      dropdownIsOpen = false
      optionViewFiredForOpen = false

      const widgetId = event.target.value
      const payload = syncLastSelectedFromValue(widgetId)
      if (payload && window.GTMDataLayer) {
        window.GTMDataLayer.suggestedBundleOptionSelect(payload)
      }
    })

    selectEl.addEventListener('blur', () => {
      // change already cleared open state; blur after dismiss without change = closed
      if (dropdownIsOpen) {
        markClosed('dismissed')
      }
    })

    if ('IntersectionObserver' in window) {
      dropdownViewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            dropdownViewPending = true
            trackDropdownView()
          })
        },
        { threshold: 0.25 }
      )
      dropdownViewObserver.observe(selectEl)
    } else {
      dropdownViewPending = true
      trackDropdownView()
    }
  }

  const onSelectSuggestedBundle = (event) => {
    const widgetId = event.target.value
    if(widgetId !== '') {
      history.pushState({}, '', `${rebuyByobSuggestedData['collection_url']}?preset=${widgetId}`)
      renderBySuggestedBundle(widgetId)
    } else {
      history.pushState({}, '', rebuyByobSuggestedData['collection_url'])
      renderBySuggestedBundle(widgetId)
    }
  }

  const renderBySuggestedBundle = (widgetId) => {
    const bundleWidgetBlock = document.querySelector(`.rebuy-byob div[data-rebuy-id="${rebuyByobSuggestedData['builder_id']}"]`)
    if(widgetId !== '') {
      const widgetBlock = document.querySelector(`.rebuy-byob div[data-rebuy-id="${widgetId}"]`)
      if(widgetBlock) {
        const variantIds = [...widgetBlock.querySelectorAll('.rebuy-product-title a')].map(link => getVariantIdFromUrl(link))
        if(variantIds.length) {
          if(bundleWidgetBlock) {
            const productBlocks = [...bundleWidgetBlock.querySelectorAll('.rebuy-product-block')]
            productBlocks.forEach(productBlock => {
              const qtyElem = productBlock.querySelector('button.rebuy-bundle-builder__item-quantity-widget-button')
              const titleElem = productBlock.querySelector('a.rebuy-product-title')
              if(qtyElem && titleElem) {
                const variantId = getVariantIdFromUrl(titleElem)
                if(!variantIds.includes(variantId)) {
                  qtyElem.click()
                }
              }
            })

            productBlocks.forEach(productBlock => {
              const titleElem = productBlock.querySelector('a.rebuy-product-title')
              if(titleElem) {
                const variantId = getVariantIdFromUrl(titleElem)
                if(variantIds.includes(variantId)) {
                  const addToCartBtn = productBlock.querySelector('.rebuy-product-actions .rebuy-button')
                  if(addToCartBtn) {
                    addToCartBtn.click()
                  }
                }
              }
            })
          }
        }
      }
    } else {
      if(bundleWidgetBlock) {
        const productBlocks = [...bundleWidgetBlock.querySelectorAll('.rebuy-product-block')]
        productBlocks.forEach(productBlock => {
          const qtyElem = productBlock.querySelector('button.rebuy-bundle-builder__item-quantity-widget-button')
          if(qtyElem) {
            qtyElem.click()
          }
        })
      }
    }
  }

  document.addEventListener('rebuy.addBundleToCart', function(event){
    const suggestedSelect = document.querySelector(
      '.rebuy-suggested-bundle-container select'
    )
    // Refresh from current select value so URL `preset` (no change event) still attributes ATC
    if (suggestedSelect?.value) {
      syncLastSelectedFromValue(suggestedSelect.value)
    } else {
      lastSelectedBundle = null
    }

    if (lastSelectedBundle && window.GTMDataLayer) {
      window.GTMDataLayer.suggestedBundleAddToCart(lastSelectedBundle)
    }

    const $miniCart = document.querySelector("mini-cart");
    const sectionIDs = $miniCart.getSectionsToRender().map((section) => section.id);
    const url = `${location.pathname}?sections=${sectionIDs}`
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        const data = {
          sections: response
        }
        $miniCart.renderContents(data);
        const $miniCartItems = $miniCart.querySelector('cart-items')
        if($miniCartItems && window.promo_gwp) {
          $miniCartItems.getCartBeforePromo()
        }
        $miniCart.openDrawer()
      })
      .catch((e) => {
        console.error(e);
      });
  });

  document.addEventListener('rebuy.ready', function(event){
    const { widget } = event.detail
    if(rebuyByobSuggestedData) {
      widgetIdList = rebuyByobSuggestedData['list'].map(item => item['widget_id'])
      widgetIdList.push(rebuyByobSuggestedData['builder_id'])
      widgetIdList.sort()

      const widgetIdStr = widget.id.toString()
      const suggestedMeta = rebuyByobSuggestedData.list.find(
        (item) => item.widget_id === widgetIdStr
      )
      if (suggestedMeta) {
        const fromApi = extractProductsFromWidgetApi(widget)
        suggestedBundleOptionCache[widgetIdStr] = {
          products: fromApi || extractProductsFromDom(widgetIdStr)
        }
        if (dropdownViewPending) {
          trackDropdownView()
        }
        // Keep preset selection payload current as product data arrives
        const selectedSelect = document.querySelector(
          '.rebuy-suggested-bundle-container select'
        )
        if (selectedSelect?.value === widgetIdStr) {
          syncLastSelectedFromValue(widgetIdStr)
        }
      }

      if(widgetIdStr === rebuyByobSuggestedData['builder_id']) {
        const sideBarElem = document.querySelector('.rebuy-bundle-builder__group-container-inner')
        const bodyElem = document.querySelector('.rebuy-bundle-builder__group-container-body')
        if(sideBarElem && bodyElem) {
          const suggestedListContainer = sideBarElem.querySelector('.rebuy-suggested-bundle-container')
          if(!suggestedListContainer) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            widgetIdFromUrl = (urlParams.get('preset') || '').trim()

            const suggestedListContainerDiv = document.createElement('div')
            suggestedListContainerDiv.classList.add('rebuy-suggested-bundle-container')
            suggestedListContainerDiv.innerHTML = `
              <div class="rebuy-suggested-bundle-options">
                <select aria-label="${rebuyByobSuggestedData['placeholder']}" class="rebuy-select">
                  <option value="">${rebuyByobSuggestedData['placeholder']}</option>
                  ${rebuyByobSuggestedData['list'].map(item => `<option value="${item['widget_id']}">${item['label']}</option>`).join('')}
                </select>
              </div>
            `
            bodyElem.before(suggestedListContainerDiv)
            const suggestedListSelect = sideBarElem.querySelector('.rebuy-suggested-bundle-container select')
            suggestedListSelect.addEventListener('change', onSelectSuggestedBundle)
            suggestedListSelect.value = widgetIdFromUrl
            // Programmatic value assignment does not fire `change`
            syncLastSelectedFromValue(widgetIdFromUrl)
            bindSuggestedBundleAnalytics(suggestedListSelect)
          }
        }
      }

      if(widgetIdList.includes(widgetIdStr)) {
        document.dispatchEvent(
          new CustomEvent("rebuy-load-bundle-widget", {
            bubbles: true,
            detail: { widgetId: widgetIdStr },
          })
        )
      }
    }
  });

  document.addEventListener("rebuy-load-bundle-widget", (event) => {
    const widgetId = event.detail?.widgetId;
    if (widgetId) {
      if (loadedWidgetIdList.indexOf(widgetId) === -1) {
        loadedWidgetIdList.push(widgetId);
      }
      loadedWidgetIdList.sort()
      const allElementsIn = widgetIdList.every(element => loadedWidgetIdList.includes(element))
      if(allElementsIn && widgetIdFromUrl && !loadedAllWidgets) {
        loadedAllWidgets = true
        setTimeout(() => renderBySuggestedBundle(widgetIdFromUrl), 1500)
      }
    }
  });
});
